import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _, { isFunction } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';

import {
    selectCatalogosProdutos,
    fetchByIdAsync,
    fetchByFilterAsync,
} from '../../features/catalogo-produtos/catalogoProdutosSlice';

import QCXAutocompleteSelectWithSearch from '../autocomplete-select/QCXAutocompleteSelectWithSearch';

export default function QCXSelectPartNumberAutocomplete({
    label,
    name,
    filterPredicate = null,
    ...restProps
}) {
    const dispatch = useDispatch();
    const list = useSelector(selectCatalogosProdutos);
    const { values } = useFormState();
    const [defaultValue, setDefaultValue] = useState(null);

    useEffect(() => {
        dispatch(fetchByFilterAsync([]));
    }, []);

    useEffect(() => {
        const currentId = _.get(values, name);
        if (currentId) {
            const valueInList = list?.find((item) => String(item.id) === String(currentId));
            if (valueInList) {
                setDefaultValue(valueInList);
            } else {
                dispatch(fetchByIdAsync(currentId));
            }
        } else {
            setDefaultValue(null);
        }
    }, [values, name, list]);

    const filterOptions = createFilterOptions({
        stringify: (item) => `${item?.partnumber} ${item?.description || item?.especificacao || ''} ${item?.apelido || ''}`,
    });

    const getOptionLabel = (item) => {
        if (!item || !item.id) return '';
        return `${item.partnumber || 'S/N'} - ${item.especificacao || item.description || ''}`;
    };

    const searchPartNumbers = (searchValue) => {
        if (!searchValue) {
            dispatch(fetchByFilterAsync([]));
            return;
        }

        if (searchValue.length >= 4) {
            const params = [
                { name: 'partnumber', value: searchValue }
            ];
            dispatch(fetchByFilterAsync(params));
        }
    };

    return (
        <QCXAutocompleteSelectWithSearch
            label={label}
            id={name}
            name={name}
            onEventActionPaiFunction={searchPartNumbers}
            options={list || []}
            filterOptions={filterOptions}
            defaultValue={defaultValue}
            getOptionLabel={getOptionLabel}
            placeholder="Busque por Part Number ou Descrição..."
            {...restProps}
        />
    );
}